import React from 'react';
import PropTypes from 'prop-types';

import {
  Body,
  Heading,
} from '../coreui';

import CalloutFrame from './CalloutFrame';

const CalloutFrameImage = ({
  bg,
  heading,
  body,
  ...additionalProps
}) => {
  return (
    <CalloutFrame
      bg={bg}
      {...additionalProps}
    >
      <Heading
        type="H2"
        mt={0}
      >
        {heading}
      </Heading>
      {
        body.map((item) => {
          return (
            <Body
              key={item}
              type="B1"
              mb={0}
            >
              {item}
            </Body>
          );
        })
      }
    </CalloutFrame>
  );
};

CalloutFrameImage.propTypes = {
  bg: PropTypes.string,
  heading: PropTypes.string,
  body: PropTypes.arrayOf(PropTypes.string),
};

CalloutFrameImage.defaultProps = {
  bg: 'gray.0',
};

export default CalloutFrameImage;
